import { ModelAdapter } from "../../../../../shared/models/adapter/ModelAdapter";
import { AppApplicationModel } from "./AppApplicationModel";
import { DsgvoAuskunftRequestApi } from '../../../../../shared/models/generated/MitgliedschaftDsgvoAuskunftRequestApi';

export class AppModelAdapter extends ModelAdapter {
	public static getDsgvoAuskunftRequestApi(appModel: AppApplicationModel, htmlFragment: string): DsgvoAuskunftRequestApi {
		const model = new DsgvoAuskunftRequestApi();
		model.ProcessId = Number(appModel.Vorgangsnummer);
		model.HtmlFragment = htmlFragment;

		if (appModel.FormModel.Delivery === "2" && appModel.FormModel.Email) {
			model.Email = appModel.FormModel.Email;
		}

		return model;
	}
}